/**
 * Demo mode for Synapse / conversation flows (fake transcript, FAKE_PRIMER, Ray-Ban auto-navigate).
 * When enabled via localStorage, demo-only behaviors run; otherwise they are disabled.
 */
const DEMO_MODE_KEY = 'cpt-synapse-demo-mode';

export function isDemoMode() {
  try {
    return localStorage.getItem(DEMO_MODE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setDemoMode(enabled) {
  try {
    if (enabled) {
      localStorage.setItem(DEMO_MODE_KEY, 'true');
    } else {
      localStorage.removeItem(DEMO_MODE_KEY);
    }
  } catch (e) {
    console.warn('demoStorage: could not set demo mode', e);
  }
}
